<div class="calculator__right">
  <div>

    <div class="container">
      <div class="calculator__right-top">
        <div class="calculator__right-title">Данные о грузе</div>
        <div class="calculator__right-top__checkboxes">
          <el-radio-group v-model="dataForm.cargoInformation.cargoSpaceType" :disabled="dataForm.consignee.cityTo.includes('(Москва)')" class="calculator__right-checkbox__wrap">
            <el-radio label="detailed">Одно или несколько мест отдельно</el-radio>
            <el-radio label="simple">Общий вес и объем</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="package-place-area" v-if="dataForm.cargoInformation.cargoSpaceType=='detailed'">
        <el-tabs v-model="dataForm.cargoSpaceData" type="card" closable class="calculator__spot__buttons__wrapper" @edit="cargoSpaceTabsEdit">
          <el-tab-pane v-for="cargoSpaceTab in dataForm.cargoSpaceTabs" :key="cargoSpaceTab.name"
            :label="cargoSpaceTab.title" :name="cargoSpaceTab.name">
            <el-collapse-transition name="el-fade-in-linear">
              <div v-show="!dataForm.sender.first_step_pass">

                <div class="container__item align-items--flex-end_el-form-item__content container__item--order--1">
                  <el-form-item>
                    <el-form-item prop="cargoInformation.typeOfCargo"
                      class="calculator__input calculator__input-cargo-type">
                      <el-select v-model="cargoSpaceTab.typeOfCargo" placeholder="Выберите вариант">
                        <el-option v-for="type in typeOfCargos" :key="type.value" :label="type.label"
                          :value="type.value" />
                      </el-select>
                    </el-form-item>
                  </el-form-item>
                </div>

                <div
                  class="container__item align-items--flex-end_el-form-item__content container__item--order--2 align-items--flex-start">
                  <div class="" v-if="cargoSpaceTab.typeOfCargo !== 'Шины'">
                    <div class="calculator__cargo_weight">
                      <div class="calculator__cargo-texts">
                        <div class="calculator__cargo__weight-title">Вес груза</div>
                        <div class="calculator__cargo__weight-value">
                          <input class="value-weight-input hide" v-model="cargoSpaceTab.cargoWeight" type="text"
                          @input="cargoWeightInputChangeTab">
                          

                          <span>&nbsp;&nbsp;кг</span>
                        </div>
                      </div>
                      <el-form-item>
                        <el-slider v-model="dataForm.cargoInformationSlidersTabs[cargoSpaceTab.counter].cargoWeightSlider" @pointerdown="dataForm.events.selecting = true" @pointerup="changeСargoWeightTab"
                          @keyup="changeСargoWeightTab" :show-tooltip="false" :min="1" :max="201" @input="cargoWeightSliderSwitchTab" />
                        <div class="total-weight--error"
                          v-if="checkDayToDay((!cargoSpaceTab.pickupDate) ? null :cargoSpaceTab.pickupDate) && checkCity()">
                          День в день до
                          <span v-if="!checkHour()">12:00, больше</span>
                          <span v-else>15:00, меньше</span>
                          30кг
                        </div>
                      </el-form-item>
                      <div class="total-weight--error mt-error"
                        v-if="(cargoSpaceTab.cargoWeight > dataForm.restrictions.weight)">
                        Укажите не более {{dataForm.restrictions.weight}} кг, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                      </div>
                      <div class="total-weight--error mt-error"
                        v-if="(calcAllWeight() > dataForm.restrictions.weightUnit)">
                        Укажите не более {{dataForm.restrictions.weightUnit}} кг, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                      </div>
                      <p 
                          v-if="dataForm.consignee?.cityTo.includes('(Москва)')"
                          class="order-creation-form__note order-creation-form__label_cargo"
                      >
                          Разрешенный вес одного места 50-300 кг
                      </p>
                    </div>



                    <div v-if="cargoSpaceTab.typeOfCargo !== 'Цилиндры'">
                      <div class="calculator__cargo__volume">
                        <div class="calculator__cargo-texts">
                          <div class="calculator__cargo__volume-title">Объем</div>
                          <div class="calculator__cargo__volume-value">
                            <input type="number" class="value-volume-input hide" @input="changeMaxСargoVolumeTab"
                              v-model="cargoSpaceTab.cargoVolume" id="volumeRangeInputText">
                            
                            <span>&nbsp;&nbsp;м<sup>3</sup></span>
                          </div>
                        </div>
                        <el-form-item prop="cargoInformation.cargoWeight">
                          <el-slider v-model="dataForm.cargoInformationSlidersTabs[cargoSpaceTab.counter].cargoVolumeSlider" :show-tooltip="false" :max="2000" @pointerdown="dataForm.events.selecting = true"
                            @keyup="changeСargoVolumeTab" @input="cargoVolumeSliderSwitchTab"/>
                          <div class="total-weight--error"
                            v-if="checkDayToDay((!cargoSpaceTab.pickupDate) ? null :cargoSpaceTab.pickupDate) && checkCity()">
                            День в день до
                            <span v-if="!checkHour()">12:00, больше</span>
                            <span v-else>15:00, меньше</span>
                            30кг
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container__item">

                  <div class="container__item align-items--flex-end_el-form-item__content container__item--order--0">
                    <template v-if="cargoSpaceTab.typeOfCargo !== 'Шины'">
                      <el-form-item v-if="cargoSpaceTab.typeOfCargo === 'Цилиндры'" class="m-0">
                        <div class="calculator__cargo__dimensions">
                          <div class="calculator__cargo__dimensions-title calculator__cargo__dimensions-title_fixate_width">Габариты груза</div>
                          <el-form-item class="calculator__cargo__size-input">
                            <div class="package-input__label">В</div>
                            <el-input type="number" placeholder="В" name="tab-v" v-model="cargoSpaceTab.height" min="15.87"
                              class="hidden_el-input-group__append"
                              @input="calculateVolumeTab('cargoSpaceTab.height')">
                            </el-input>
                          </el-form-item>
                          х
                          <el-form-item class="calculator__cargo__size-input">
                            <div class="package-input__label">Д</div>
                            <el-input type="number" placeholder="Д" name="tab-d" v-model="cargoSpaceTab.diameter" min="15.87"
                              class="hidden_el-input-group__append"
                              @input="calculateVolumeTab('cargoSpaceTab.diameter')">
                            </el-input>
                          </el-form-item>
                          <div>см</div>
                        </div>
                      </el-form-item>

                      <el-form-item class="m-0" v-else>
                        <div class="calculator__cargo__dimensions">
                          <div class="calculator__cargo__dimensions-title calculator__cargo__dimensions-title_fixate_width">Габариты груза</div>

                          <el-form-item class="calculator__cargo__size-input">
                            <div class="package-input__label">Д</div>
                            <el-input type="number" placeholder="Д" name="tab-d" v-model="cargoSpaceTab.length" min="15.87"
                              class="hidden_el-input-group__append" @input="calculateVolumeTab('cargoSpaceTab.length')">
                            </el-input>
                          </el-form-item>
                          х
                          <el-form-item prop="" class="calculator__cargo__size-input">
                            <div class="package-input__label">Ш</div>
                            <el-input type="number" placeholder="Ш" name="tab-sh" v-model="cargoSpaceTab.width" min="15.87"
                              class="hidden_el-input-group__append" @input="calculateVolumeTab('cargoSpaceTab.width')">
                            </el-input>
                          </el-form-item>

                          х
                          <el-form-item class="calculator__cargo__size-input">
                            <div class="package-input__label">В</div>
                            <el-input type="number" placeholder="В" name="tab-v" v-model="cargoSpaceTab.height" min="15.87"
                              class="hidden_el-input-group__append" @input="calculateVolumeTab('cargoSpaceTab.height')">
                            </el-input>
                          </el-form-item>
                          <div>см</div>

                        </div>
                      </el-form-item>
                    </template>

                    <div class="total-weight--error" v-if="(cargoSpaceTab.height > dataForm.restrictions.height)">
                      Укажите не более {{dataForm.restrictions.height}} см высоты, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                    </div>
                    <div class="total-weight--error" v-if="(cargoSpaceTab.length > dataForm.restrictions.size)">
                      Укажите не более {{dataForm.restrictions.size}} см длины, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                    </div>
                    <div class="total-weight--error" v-if="(cargoSpaceTab.width > dataForm.restrictions.size)">
                      Укажите не более {{dataForm.restrictions.size}} см ширины, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                    </div>
                    <p 
                        v-if="dataForm.consignee?.cityTo.includes('(Москва)')"
                        class="order-creation-form__note order-creation-form__label_cargo"
                    >
                        Разрешенные габариты одного места до 120х80х120 см
                    </p>
                    
                  </div>
                  <div class="first-page-bottom-line">
                    <div class="w-100">
                      <div class="uslugi">
                        <div class="uslugi__area uslugi__area_type_title-with-input" :class="(dataForm.other.cargoCost >= 30000) ? 'mb-error' : ''">
                          <el-form-item>
                            <div class="calculator__cargo__cost-title calculator__cargo__dimensions-title_fixate_width dimensions-title_fixate_unset">Объявленная стоимость груза</div>
                          </el-form-item>
                          <el-form-item>
                            <el-form-item class="uslugi__input">
                              <el-form-item class="calculator__toggle-input"
                                prop="cargoInformation.cargoCost">
                                <el-input type="number" v-model="dataForm.other.cargoCost" min="0"
                                @change="if(dataForm.other.cargoCost < 3000) dataForm.other.cargoCost = 3000; changeCargoCost()" />
                              </el-form-item>
                              <div class="total-weight--error" v-if="dataForm.other.cargoCost >= 30000">
                                Обрешетка может быть обязательной - в зависимости от характера груза
                              </div>
                            </el-form-item>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="first-page-bottom-line pay-switcher">
                        <div class="pay-switcher__title calculator__cargo__cost-title">
                          Плательщик перевозки
                        </div>
                        <el-form-item>
                          <el-radio-group v-model="dataForm.consigneeInnRadio" :disabled="!!dataForm.thirdPerson.cargoTransportationCustomer" @change="consigneeInnRadioChange">
                            <el-radio :label="false">Физическое лицо</el-radio>
                            <el-radio :label="true">Юридическое лицо</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  
                  
                  
                </div>
              </div>
            </el-collapse-transition>
            <el-collapse-transition name="el-fade-in-linear">
              <div v-show="dataForm.sender.first_step_pass">
                <ServicesPartialTab :cargoSpaceTab="cargoSpaceTab" />
              </div>
            </el-collapse-transition>
          </el-tab-pane>
        </el-tabs>
        <div class="calculator__addSpotButton" @click="addTab(dataForm.cargoSpaceData)">+</div>


      </div>


      <div v-if="dataForm.cargoInformation.cargoSpaceType=='simple'">
        <el-form-item>
          <div class="calculator__spot__input">
            <span class="calculator__spots-input-title calculator__cargo__dimensions-title_fixate_width">Количество мест: </span>
            <el-form-item prop="cargoInformation.numberOfIdenticalLoads" class="calculator__spot-input mb-0">
              <el-input v-model="dataForm.cargoInformation.numberOfIdenticalLoads" min="1" type="number"
                :disabled='dataForm.consignee?.cityTo.includes("(Москва)")'
                class="hidden_el-input-group__append" @change="checkNumberOfIdenticalLoads">
              </el-input>
            </el-form-item>
          </div>
        </el-form-item>
        <el-collapse-transition name="el-fade-in-linear">
          <div v-show="!dataForm.sender.first_step_pass">
            <div class="container__item align-items--flex-end_el-form-item__content container__item--order--1">
              <el-form-item>
                <el-form-item prop="cargoInformation.typeOfCargo"
                  class="calculator__input calculator__input-cargo-type">
                  <el-select v-model="dataForm.cargoInformation.typeOfCargo" placeholder="Выберите вариант">
                    <el-option v-for="typeCargo in typeOfCargos" :key="typeCargo.value" :label="typeCargo.label" :value="typeCargo.value" />
                  </el-select>
                </el-form-item>
              </el-form-item>
            </div>

            <div
              class="container__item align-items--flex-end_el-form-item__content container__item--order--2 align-items--flex-start">
              <div v-if="dataForm.cargoInformation.typeOfCargo !== 'Шины'">
                <el-form-item class="calculator__cargo_weight" prop="cargoInformation.cargoWeight">
                  <div class="calculator__cargo-texts">
                    <div class="calculator__cargo__weight-title">Вес груза</div>
                    <div class="calculator__cargo__weight-value">
                      <input class="value-weight-input hide" @input="cargoWeightInputChange" v-model="dataForm.cargoInformation.cargoWeight" type="text" id="weightRangeInputText">
                      
                      <span>&nbsp;&nbsp;кг</span>
                    </div>
                  </div>
                  <!-- dataForm.cargoInformation.cargoWeight -->
                  <el-form-item>
                    <el-slider v-model="dataForm.cargoInformationSliders.cargoWeightSlider" @pointerdown="dataForm.events.selecting = true" @keyup="changeСargoWeight" :show-tooltip="false" :max="201"
                      :min="1" @input="cargoWeightSliderSwitch" />
                    <div class="total-weight--error"
                      v-if="checkDayToDay(dataForm.applicationCargoPickup.pickupDate) && checkCity()">
                      День в день до
                      <span v-if="!checkHour()">12:00, больше</span>
                      <span v-else>15:00, меньше</span>
                      30кг
                    </div>
                  </el-form-item>
                  <div class="total-weight--error mt-error"
                    v-if="(dataForm.cargoInformation.cargoWeight / dataForm.cargoInformation.numberOfIdenticalLoads > dataForm.restrictions.weight)">
                    Укажите не более {{dataForm.restrictions.weight}} кг, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                  </div>
                  <div class="total-weight--error mt-error"
                        v-if="(dataForm.cargoInformation.cargoWeight > dataForm.restrictions.weightUnit)">
                        Укажите не более {{dataForm.restrictions.weightUnit}} кг, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                  </div>
                  <p 
                      v-if="dataForm.consignee?.cityTo.includes('(Москва)')"
                      class="order-creation-form__note order-creation-form__label_cargo"
                  >
                      Разрешенный вес одного места 50-300 кг
                  </p>
                </el-form-item>



                <div v-if="dataForm.cargoInformation.typeOfCargo !== 'Цилиндры'">
                  <div class="calculator__cargo__volume">
                    <div class="calculator__cargo-texts">
                      <div class="calculator__cargo__volume-title">Объем</div>
                      <div class="calculator__cargo__volume-value">
                        <input class="value-volume-input hide" @input="changeMaxСargoVolume"
                          v-model="dataForm.cargoInformation.cargoVolume"  type="text" id="volumeRangeInputText">
                        
                        <span>&nbsp;&nbsp;м<sup>3</sup></span>
                      </div>
                    </div>
                    <el-form-item>
                      <el-slider v-model="dataForm.cargoInformationSliders.cargoVolumeSlider" :show-tooltip="false" :max="2000" @pointerdown="dataForm.events.selecting = true"
                      @keyup="changeСargoVolume" @input="cargoVolumeSliderSwitch" />
                      <div class="total-weight--error"
                        v-if="checkDayToDay(dataForm.applicationCargoPickup.pickupDate) && checkCity()">
                        День в день до
                        <span v-if="!checkHour()">12:00, больше</span>
                        <span v-else>15:00, меньше</span>
                        30кг
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>

            <div class="container__item">
              <div class="container__item align-items--flex-end_el-form-item__content container__item--order--0">
                <template v-if="dataForm.cargoInformation.typeOfCargo !== 'Шины'">
                  <el-form-item v-if="dataForm.cargoInformation.typeOfCargo === 'Цилиндры'" class="m-0">
                    <div class="calculator__cargo__dimensions">
                      <div class="calculator__cargo__dimensions-title calculator__cargo__dimensions-title_fixate_width">Габариты груза</div>
                      <el-form-item prop="cargoInformation.sizeOfCargoCylinder.height"
                        class="calculator__cargo__size-input">
                        <div class="package-input__label">В</div>
                        <el-input type="number" placeholder="В" name="cargo-v"
                          v-model="dataForm.cargoInformation.sizeOfCargoCylinder.height" min="15.87"
                          class="hidden_el-input-group__append"
                          @input="calculateVolumeCylinder('sizeOfCargoCylinder.height')">
                        </el-input>
                      </el-form-item>
                      х
                      <el-form-item prop="cargoInformation.sizeOfCargoCylinder.diameter"
                        class="calculator__cargo__size-input">
                        <div class="package-input__label">Д</div>
                        <el-input type="number" placeholder="Д" name="cargo-d"
                          v-model="dataForm.cargoInformation.sizeOfCargoCylinder.diameter" min="15.87"
                          class="hidden_el-input-group__append"
                          @input="calculateVolumeCylinder('sizeOfCargoCylinder.diameter')">
                        </el-input>
                      </el-form-item>
                      <div>см</div>
                    </div>
                  </el-form-item>

                  <el-form-item class="m-0" v-else>
                    <div class="calculator__cargo__dimensions">
                      <div class="calculator__cargo__dimensions-title calculator__cargo__dimensions-title_fixate_width">Габариты груза</div>
                      <el-form-item prop="cargoInformation.cargoDimensions.length"
                        class="calculator__cargo__size-input">
                        <div class="package-input__label">Д</div>
                        <el-input type="number" placeholder="Д" name="cargo-d"
                          v-model="dataForm.cargoInformation.cargoDimensions.length" min="15.87"
                          class="hidden_el-input-group__append" @input="calculateVolume('cargoDimensions.length')">
                        </el-input>
                      </el-form-item>
                      х
                      <el-form-item prop="cargoInformation.cargoDimensions.width" class="calculator__cargo__size-input">
                        <div class="package-input__label">Ш</div>
                        <el-input type="number" placeholder="Ш" name="cargo-sh"
                          v-model="dataForm.cargoInformation.cargoDimensions.width" min="15.87"
                          class="hidden_el-input-group__append" @input="calculateVolume('cargoDimensions.width')">
                        </el-input>
                      </el-form-item>
                      х
                      <el-form-item prop="cargoInformation.cargoDimensions.height"
                        class="calculator__cargo__size-input">
                        <div class="package-input__label">В</div>
                        <el-input type="number" placeholder="В" name="cargo-v"
                          v-model="dataForm.cargoInformation.cargoDimensions.height" min="15.87"
                          class="hidden_el-input-group__append" @input="calculateVolume('cargoDimensions.height')">
                        </el-input>
                      </el-form-item>
                      <div>см</div>
                    </div>
                  </el-form-item>
                </template>
                <div class="total-weight--error" v-if="(dataForm.cargoInformation.cargoDimensions.height > dataForm.restrictions.height)">
                  Укажите не более {{dataForm.restrictions.height}} см высоты, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                </div>
                <div class="total-weight--error" v-if="(dataForm.cargoInformation.cargoDimensions.length > dataForm.restrictions.size)">
                  Укажите не более {{dataForm.restrictions.size}} см длины, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                </div>
                <div class="total-weight--error" v-if="(dataForm.cargoInformation.cargoDimensions.width > dataForm.restrictions.size)">
                  Укажите не более {{dataForm.restrictions.size}} см ширины, или <a href="https://тк-луч.рф/onlajn-servisy/#delivery-form">заполните форму</a> на перевозку отдельной машиной.
                </div>
                <p 
                    v-if="dataForm.consignee?.cityTo.includes('(Москва)')"
                    class="order-creation-form__note order-creation-form__label_cargo"
                >
                    Разрешенные габариты одного места до 120х80х120 см
                </p>
              </div>
              <div class="first-page-bottom-line">
                <div class="w-100">
                  <div class="uslugi">
                    <div class="uslugi__area uslugi__area_type_title-with-input" :class="(dataForm.other.cargoCost >= 30000) ? 'mb-error' : ''">
                      <el-form-item>
                        <div class="calculator__cargo__cost-title calculator__cargo__dimensions-title_fixate_width">Объявленная стоимость груза</div>
                      </el-form-item>
                      <el-form-item>
                        <el-form-item class="uslugi__input">
                          <el-form-item class="calculator__toggle-input"
                            prop="cargoInformation.cargoCost">
                            <el-input type="number" v-model="dataForm.other.cargoCost" min="0"
                            @change="if(dataForm.other.cargoCost < 3000) dataForm.other.cargoCost = 3000; changeCargoCost()" />
                          </el-form-item>
                          <div class="total-weight--error" v-if="dataForm.other.cargoCost >= 30000">
                            Обрешетка может быть обязательной - в зависимости от характера груза
                          </div>
                        </el-form-item>
                      </el-form-item>
                    </div>
                  </div>
                  
                  <!-- <div class="calculator__additionalPackaging">
                    <div class="calculator__additionalPackaging-top">
                      <div class="calculator__additionalPackaging-title">Дополнительная упаковка</div>
                      <div class="calculator__additionalPackaging__toggle-inner">
                        <el-switch v-model="dataForm.cargoInformation.additionalPackaging"
                          @change="dataForm.packages.additionalPackagingGroup = dataForm.cargoInformation.additionalPackaging ? dataForm.packages.additionalPackagingGroup : []"
                          />
                      </div>
                    </div>
                  </div> -->

                  <div class="first-page-bottom-line pay-switcher">
                    <div class="pay-switcher__title calculator__cargo__cost-title">
                      Плательщик перевозки
                    </div>
                    <el-form-item>
                      <el-radio-group v-model="dataForm.consigneeInnRadio" :disabled="!!dataForm.thirdPerson.cargoTransportationCustomer" @change="consigneeInnRadioChange">
                        <el-radio :label="false">Физическое лицо</el-radio>
                        <el-radio :label="true">Юридическое лицо</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <el-dialog v-model="visible">
                <template #header="{ close, titleId, titleClass }">
                  <div class="my-header">
                    <h4 :id="titleId" :class="titleClass">{{dialogTitle}}</h4>
                  </div>
                </template>
                <div v-html="dialogText">
                </div>
              </el-dialog>


              
            </div>

          </div>
        </el-collapse-transition>
        <el-collapse-transition name="el-fade-in-linear">
          <div v-show="dataForm.sender.first_step_pass">
            <ServicesPartial />
          </div>
        </el-collapse-transition>
      </div>
    </div>


  </div>



</div>


<el-collapse-transition name="el-fade-in-linear">
  <div class="calculateArrow" v-if="!dataForm.sender.first_step_pass">
    <div class="step-counter">1/{{ dataForm.totalSteps }}</div>
    <div class="arrows-steps-prev disable" @click="$emit('click-button-back')"></div>
    <div class="arrows-steps-next"
      @click="$emit('check-first-page',[...getArrayOfRules((({ natureOfCargo, ...object }) => object)(dataForm.cargoInformation), 'cargoInformation')])">
    </div>
  </div>
</el-collapse-transition>

<el-collapse-transition name="el-fade-in-linear">
  <div class="calculateArrow" v-if="dataForm.sender.first_step_pass">
    <div class="step-counter">2/{{ dataForm.totalSteps }}</div>
    <div class="arrows-steps-prev" @click="backButtonActionFirstPage"></div>
    <div class="arrows-steps-next"
      @click="$emit('click-button-next', [...getArrayOfRules({natureOfCargo: dataForm.cargoInformation.natureOfCargo }, 'cargoInformation'), ...getArrayOfRules({cityFrom: dataForm.sender.cityFrom, officeFrom: dataForm.sender.officeFrom}, 'sender'),  ...getArrayOfRules({cityTo: dataForm.consignee.cityTo, officeTo: dataForm.consignee.officeTo}, 'consignee'), ...getArrayOfRules((({ typePowerOfAttorney, ...object }) => object)(dataForm.services), 'services'), ...(dataForm.cargoInformation.cargoSpaceType == 'simple' ? ['packages.additionalPackagingGroup'] : dataForm.packagesTabs.map((_, idx) => `packagesTabs.${idx}.additionalPackagingGroup`))], (getTabsValidate() && dataForm.cargoInformation.cargoSpaceType == 'detailed') || dataForm.cargoInformation.cargoSpaceType == 'simple')">
    </div>
  </div>
</el-collapse-transition>